<!--
 * @Descripttion:
 * @version:
 * @Author: Jiang ShareFont
 * @Date: 2022-12-08 12:04:16
 * @LastEditors:
 * @LastEditTime: 2023-06-15 14:51:23
-->
<template>
	<div class="header">
		<div class="logoImg">
    		 <img src="@/assets/image/logo2.png" alt=""  class="logo"/>
    		 <span>|</span>
    		 <a href="https://open.work.weixin.qq.com" target="_blank"><img src="https://open.work.weixin.qq.com/service/img?id=ww4244127678d07ae5&t=isp&c=white&s=small" srcset="https://open.work.weixin.qq.com/service/img?id=ww4244127678d07ae5&t=isp&c=white&s=small@2x 2x" referrerpolicy="unsafe-url" alt="企业微信"></a>
    	</div>
    	<div class="menus">
			<el-menu
			  :default-active="activeName"
			  class="el-menu-demo"
			  mode="horizontal"

			  background-color="#545c64"
			  text-color="#fff"
			  active-text-color="#ffd04b">
			  <el-menu-item index="userinfo" @click="navigatorHandle('/userinfo')">我的信息</el-menu-item>
			  <el-menu-item index="userlist" @click="navigatorHandle('/userlist')" v-if="agent==1 || usertype==1">人员管理</el-menu-item>
        <el-menu-item index="apporder"  @click="navigatorHandle('/apporderlist')">应用订单管理</el-menu-item>
			  <!-- <el-menu-item index="order"  @click="navigatorHandle('/orderlist')">订单管理</el-menu-item> -->
        <el-menu-item index="allorder" v-if="is_manager==1"  @click="navigatorHandle('/allorderlist')">管理员查看全部订单</el-menu-item>

			  <!--<el-menu-item index="4">
			  	<a href="https://www.ele.me" target="_blank">订单管理</a>
			  </el-menu-item>-->
			</el-menu>
		</div>
    <div class="selectApp" >
    	<el-dropdown @command="handleCommand">
    	  <span class="el-dropdown-link">
    	    {{suite_name}}<i class="el-icon-arrow-down el-icon--right"></i>
    	  </span>
    	  <el-dropdown-menu slot="dropdown">
    	    <el-dropdown-item v-for="item,index in suite_id_list"  :command="item"> {{item.name}}</el-dropdown-item>
    	  </el-dropdown-menu>
    	</el-dropdown>
    </div>
		<div class="loginOut"  @click="lgoinOut">
			<span>登出</span>
		</div>
	</div>
</template>

<script>

	import Cookies from "js-cookie";

	export default {
	  name: 'headerCompent',
	   components: {

	  },
	  data () {
	    return {
        suite_id_list:[
          {name:'群互动',suite_id:'wwe1672b8556d5bfeb',avatar:'https://api-group.chouchoujiang.com/static/admin/images/logo.png'},
          {name:'互动小工具',suite_id:'wwd579740c7542b9c5',avatar:'https://static.ccxia.cn/Uploads/lottery/2508/68995e100d946.png'},
          {name:'互动大转盘',suite_id:'wwae097389e8998ec1',avatar:'https://static.ccxia.cn/Uploads/lottery/2508/68995e50b605a.png'},
          {name:'互动活动',suite_id:'wwd90c4c627ba10fad',avatar:'https://static.ccxia.cn/Uploads/lottery/2508/68995ed02934a.png'},
        ],
	    }
	  },
	  props: ['activeName','agent','usertype','is_manager','suite_id','suite_name'],
	  watch: {
	     agent : function(n,o){



	    }

	  },
	  methods:{
	  	lgoinOut(){
	  		Cookies.remove('token');
	  		Cookies.remove('agent');
	  		Cookies.remove('usertype');
	  		this.$router.push('/login')
	  	},

	  	handleCommand(item){
        Cookies.set('suite_id',item.suite_id,{ expires: 7 });
        Cookies.set('suite_name',item.name,{ expires: 7 });
        window.location.reload();

	  	},
      navigatorHandle(e){

      	if(e == this.$route.path){
      		return false;
      	}
      	else{
      		this.$router.push(e);
      	}
      }


	  },
	  created(){

	  },
	  mounted(){

	  }
	}
</script>

<style scoped  type="text/scss" lang="scss" >
	.header{
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: rgb(84, 92, 100);
		.logoImg{
        	display: flex;
        	justify-content:space-around;
        	align-items: center;
        	margin:0 auto;
        	width:250px;
        	height: 61px;
        	padding:0 25px;

        	.logo{
        		width: 66px;
                height: 37px;
        	}
        	span{
        		color: #ECECEC;
        	}
        	a{
        		img{
        			display: block;
        		}
        	}
        }
        .menus{
        	flex: 1;
        	padding-left: 50px;
        }
        .loginOut{
        	width: 40px;
        	line-height: 50px;
        	font-size: 12px;
        	color: #FFFFFF;
        	padding: 0 10px;
        	height: 50px;
        	cursor: pointer;
        }
        .selectApp{
          width: 170px;
          text-align: right;
          .el-dropdown-link{
            	color: #FFFFFF;
          }
        }
	}

</style>



// WEBPACK FOOTER //
// src/components/header.vue